<template>
    <div>
        <div class="tree-form-box">

            <div class="tree-form-tree">
                <slot name="tree">
<!--                    <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>-->
                </slot>
            </div>


            <div class="tree-form-form-box">

                <div class="btn-group" >

                    <slot name="btn-group">
<!--                        <el-button-group style="display: inline-block">-->
<!--                            <el-button @click.stop="handleAddBrother" size="small">-->
<!--                                新增同级节点-->
<!--                            </el-button>-->
<!--                            <el-button @click="handleAddChild" size="small">新增子节点-->
<!--                            </el-button>-->
<!--                            <el-button @click="handleDeleteNode" size="small">删除此节点-->
<!--                            </el-button>-->
<!--                        </el-button-group>-->
                    </slot>

                </div>

                <div class="tree-form-form">


                    <slot name="form">

<!--                        <el-form ref="form" :model="moduleForm" :rules="moduleFormRules" label-width="80px" style="max-width: 300px;">-->

<!--                            <el-form-item label="模块名称">-->
<!--                                <el-input v-model="moduleForm.name"></el-input>-->
<!--                            </el-form-item>-->


<!--                            <el-form-item label="模块编号">-->
<!--                                <el-input v-model="moduleForm.number"></el-input>-->
<!--                            </el-form-item>-->

<!--                            <el-form-item label="上级模块">-->
<!--                                <el-input ></el-input>-->
<!--                            </el-form-item>-->

<!--                            <el-form-item>-->
<!--                                <el-button type="primary" >保存</el-button>-->
<!--                            </el-form-item>-->
<!--                        </el-form>-->

                    </slot>


                </div>

            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "TreeForm"
    }
</script>

<style lang="scss" scoped>

    .tree-form-box {
        height: 600px;
        width: 960px;
        border: #DCDFE6 solid 1px;
    }

    .tree-form-tree, .tree-form-form-box {
        display: inline-block;
        float: left;
    }

    .tree-form-tree {
        width: 179px;
        border-right: #DCDFE6 solid 1px;
        height: calc(100% - 20px);
        padding: 10px;
    }

    .tree-form-form-box{
        width: calc(100% - 200px);
        height: 100%;

        .btn-group{
            border-bottom: 1px solid #DCDFE6;
            text-align: right;
            padding: 10px 10px;
        }

        .tree-form-form{
            padding: 10px;

        }

    }

</style>